import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { Form, Row, Col, Card, Accordion, Button } from 'react-bootstrap';
import { ASYNC_CREATE_PROFILE, ASYNC_EDIT_PROFILE } from 'store';
import { useTranslation } from 'react-i18next';
import { api } from 'services';
import FormControl from 'helpers/FormControl';
import MasterPage from 'components/MasterPage';
import Select from 'react-select';
import { DashboardOutlined } from '@material-ui/icons';

const ProfilesForm = ({
  createOrEditProfile,
  match: {
    params: { id },
  },
}) => {
  const [name, setName] = useState('');
  const [area_id, setAreaId] = useState('');
  const [profile_type_id, setProfileTypeId] = useState('');
  const [areas, setAreas] = useState([]);
  const [permissions, setPermissions] = useState([]);
  const [permissionGroups, setPermissionGroups] = useState([]);
  const [profileTypes, setProfileTypes] = useState([]);
  const [stepsAction, setStepsAction] = useState([]);
  const [stepsPlan, setStepsPlan] = useState([]);
  const [stepsCreative, setStepsCreative] = useState([]);
  const [flowsAction, setFlowsAction] = useState([]);
  const [flowsPlan, setFlowsPlan] = useState([]);
  const [flowsCreative, setFlowsCreative] = useState([]);
  const [nfApprovalPermissions, setNfApprovalPermissions] = useState([]);
  const [
    currentNfApprovalPermissions,
    setCurrentNfApprovalPermissions,
  ] = useState([]);
  const [errors, setErrors] = useState([]);
  const obj = {};

  useEffect(() => {
    api.get('areas').then(({ data }) => {
      if (data.length === 1) setAreaId(data[0].id);

      setAreas(data);
    });

    api.get('permission-groups').then(({ data }) => {
      data.forEach((group) =>
        group.permissions.forEach((permission) => {
          obj[permission.id] = false;
        })
      );
      setPermissionGroups(data);
    });

    if (id) {
      api.get(`profiles/${id}`).then(({ data }) => {
        setName(data.name);
        setAreaId(data.area_id);
        data.nf_approval_permission.map((permission) => {
          setCurrentNfApprovalPermissions((state) => [
            ...state,
            { value: permission.id, label: permission.name },
          ]);
        });
        setProfileTypeId(data.profile_type_id);
        // data.permissions.forEach((p) => (obj[p.id] = true));
        setPermissions([...data.permissions].map(p=>{return p.id}));
        data.steps.map((steps) => {
          if (steps.flow.name == 'action') {
            setFlowsAction((state) => [
              ...state,
              { value: steps.id, label: t(`statuses:${steps.status.name}`) },
            ]);
          }
          if (steps.flow.name == 'marketing plan') {
            setFlowsPlan((state) => [
              ...state,
              { value: steps.id, label: t(`statuses:${steps.status.name}`) },
            ]);
          }
          if (steps.flow.name == 'creative') {
            setFlowsCreative((state) => [
              ...state,
              { value: steps.id, label: t(`statuses:${steps.status.name}`) },
            ]);
          }
        });
      });
    }

    api.get('profile-types').then(({ data }) => setProfileTypes(data));

    api.get('steps').then(({ data }) =>
      data.map((steps) => {
        if (steps.flow.name == 'action') {
          setStepsAction((state) => [
            ...state,
            { value: steps.id, label: t(`statuses:${steps.status.name}`) },
          ]);
        }
        if (steps.flow.name == 'marketing plan') {
          setStepsPlan((state) => [
            ...state,
            { value: steps.id, label: t(`statuses:${steps.status.name}`) },
          ]);
        }
        if (steps.flow.name == 'creative') {
          setStepsCreative((state) => [
            ...state,
            { value: steps.id, label: t(`statuses:${steps.status.name}`) },
          ]);
        }
      })
    );
    api.get('nf-approval-permissions').then(({ data }) =>
      data.map((data) => {
        setNfApprovalPermissions((state) => [
          ...state,
          { value: data.id, label: data.name },
        ]);
      })
    );
  }, [id]);

  const { t } = useTranslation();

  const handleChangePermission = (id) => {
    const updateObj = { ...permissions };

    updateObj[id] = !updateObj[id];

    setPermissions(updateObj);
  };

  const handleErrors = (errors) => setErrors(errors);

  const handleSubmit = (e) => {
    e.preventDefault();

    const perms = [];

    for (var p in permissions) {
      if (!permissions[p]) continue;

      perms.push(parseInt(p));
    }

    const flows = flowsAction.concat(flowsCreative).concat(flowsPlan);

    const steps = [];

    flows.map((flow) => steps.push(parseInt(flow.value)));

    const nfPerms = [];

    currentNfApprovalPermissions > 1 &&
      currentNfApprovalPermissions.map((nf_appr) =>
        nfPerms.push(parseInt(nf_appr.value))
      );

    createOrEditProfile(
      {
        id,
        name,
        area_id,
        profile_type_id,
        permissions: permissions,
        flows: steps,
        nf_appr_perms: nfPerms,
      },
      handleErrors
    );
  };

  function NewCheckBox({ state, onChange }) {
    const indetSetter = React.useCallback(
      (el) => {
        if (el && state() === 2) {
          el.indeterminate = true;
        }
      },
      [state]
    );
    return (
      <input
        type="checkbox"
        checked={state() === 1}
        ref={indetSetter}
        onClick={onChange}
      />
    );
  }

  const createRoutes = () => {
    return (
      <Accordion className="w-100">
        {permissionGroups.map((group, k) => {
          return (
            <Card key={k}>
              <Card.Header className="row justify-content-between align-items-center m-0 mt-3 w-100">
                <Col xs="auto">
                  <Accordion.Toggle eventKey={k + 1} as={Button} variant="link">
                    {t(`permission:${group.name}`)}
                  </Accordion.Toggle>
                </Col>
                <Col xs="auto" className="align-self-end">
                  <NewCheckBox
                    state={() => {
                      if (
                        group.permissions.filter(
                          (r) => permissions.indexOf(r.id) !== -1
                        ).length === group.permissions.length
                      )
                        return 1;
                      else if (
                        group.permissions.filter(
                          (r) => permissions.indexOf(r.id) !== -1
                        ).length === 0
                      )
                        return 0;
                      else return 2;
                    }}
                    onChange={(e) => {
                      let routes_aux = [...permissions];
                      if (e.target.checked)
                        group.permissions.forEach((r) => {
                          if (routes_aux.indexOf(r.id) === -1)
                            routes_aux.push(r.id);
                        });
                      else
                        group.permissions.forEach((r) => {
                          if (routes_aux.indexOf(r.id) !== -1)
                            routes_aux.splice(routes_aux.indexOf(r.id), 1);
                        });
                        setPermissions([...routes_aux]);
                    }}
                  />
                </Col>
              </Card.Header>
              <Accordion.Collapse eventKey={k + 1}>
                <Card.Body>
                  {group.permissions.map((route, k) => {
                    return (
                      <Row
                        key={k}
                        className="line-group justify-content-between"
                      >
                        <Col xs="11" className="pl-0 pr-0">
                          <span
                            style={{
                              whiteSpace: 'nowrap',
                              overflow: 'hidden',
                              textOverflow: 'ellipsis',
                              width: '100%',
                              display: 'inline-block',
                              height: '15px',
                            }}
                          >
                            {t(`permission:${route.name}`)}
                          </span>
                        </Col>
                        <Col xs="1" className="align-self-end pl-0 pr-0">
                          <Form.Check
                            checked={permissions.indexOf(route.id) !== -1}
                            onChange={(e) => {
                              let routes_aux = [...permissions];
                              if (e.target.checked) routes_aux.push(route.id);
                              else
                                routes_aux.splice(
                                  routes_aux.indexOf(route.id),
                                  1
                                );
                                setPermissions([...routes_aux]);
                            }}
                          />
                        </Col>
                      </Row>
                    );
                  })}
                </Card.Body>
              </Accordion.Collapse>
            </Card>
          );
        })}
      </Accordion>
    );
  };

  return (
    <Card.Body className="shadow bg-white rounded mb-3">
      <Form onSubmit={handleSubmit}>
        <Row>
          <Col className="d-flex mt-3 mb-3">
            <DashboardOutlined className="icon-title" />
            <h4 className="title-dashboard mt-2">{name ? `Perfil - ${name}` : t('title:create profile')}</h4>
          </Col>
        </Row>
        <Row className="mt-2">
          <Col>
            <Row>
              <Col>
                <h5>{t('title:profile data')}</h5>
              </Col>
            </Row>
            <Row className="pt-4">
              <Col>
                <Form.Group>
                  <Form.Label>{t('label:name')}</Form.Label>
                  <FormControl
                    value={name}
                    onChange={(e) => setName(e.target.value)}
                    validation={errors.name}
                    required
                  />
                </Form.Group>
              </Col>
              {areas.length > 1 ? (
                <Col>
                  <Form.Group>
                    <Form.Label>{t('label:area')}</Form.Label>
                    <FormControl
                      as="select"
                      value={area_id}
                      onChange={(e) => setAreaId(e.target.value)}
                      validation={errors.area_id}
                      required
                    >
                      <option disabled value="">
                        {t('label:select')}
                      </option>
                      {areas.map((area, k) => (
                        <option key={k} value={area.id}>
                          {area.name}
                        </option>
                      ))}
                    </FormControl>
                  </Form.Group>
                </Col>
              ) : null}
              <Col>
                <Form.Group>
                  <Form.Label>{t('label:profile type')}</Form.Label>
                  <FormControl
                    as="select"
                    value={profile_type_id}
                    onChange={(e) => setProfileTypeId(e.target.value)}
                    validation={errors.rofile_type_id}
                    required
                  >
                    <option disabled value="">
                      {t('label:select')}
                    </option>
                    {profileTypes.map((type, k) => (
                      <option key={k} value={type.id}>
                        {type.name}
                      </option>
                    ))}
                  </FormControl>
                </Form.Group>
              </Col>
            </Row>
          </Col>
        </Row>

        <Row>
          <Col>
            <Form.Label>Flow Ações</Form.Label>
            <Select
              closeMenuOnSelect={false}
              isMulti
              value={flowsAction && flowsAction}
              options={stepsAction && stepsAction}
              onChange={(selected) => setFlowsAction(selected)}
            />
          </Col>
        </Row>

        <Row>
          <Col>
            <Form.Label>Flow Plano</Form.Label>
            <Select
              closeMenuOnSelect={false}
              isMulti
              value={flowsPlan && flowsPlan}
              options={stepsPlan && stepsPlan}
              onChange={(selected) => setFlowsPlan(selected)}
            />
          </Col>
        </Row>

        <Row>
          <Col>
            <Form.Label>Flow Criativo</Form.Label>
            <Select
              closeMenuOnSelect={false}
              isMulti
              value={flowsCreative && flowsCreative}
              options={stepsCreative && stepsCreative}
              onChange={(selected) => setFlowsCreative(selected)}
            />
          </Col>
        </Row>

        <Row className="mt-2">
          <Col>
            <Row>
              <Col>
                <h5>{t('title:profile permissions')}</h5>
              </Col>
            </Row>
            <Row className="pt-4">
              <Col>
                {createRoutes()}
                {/* <Accordion defaultActiveKey="dashboard">
                  {permissionGroups.map((group, k) => (
                    <Card key={k}>
                      <Card.Header>
                        <Accordion.Toggle
                          as={Button}
                          variant="link"
                          eventKey={group.name}
                        >
                          {t(`permission:${group.name}`)}
                        </Accordion.Toggle>
                      </Card.Header>
                      <Accordion.Collapse eventKey={group.name}>
                        <Card.Body>
                          {group.permissions.map((permission, k) => (
                            <div key={k} className="pt-3 pb-3 border-bottom">
                              <Form.Check type="checkbox" id={permission.name}>
                                <Form.Check.Label>
                                  {t(`permission:${permission.name}`)}
                                </Form.Check.Label>
                                <div className="float-right">
                                  <Form.Check.Input
                                    checked={permissions[permission.id]}
                                    onChange={() =>
                                      handleChangePermission(permission.id)
                                    }
                                  />
                                </div>
                              </Form.Check>
                            </div>
                          ))}
                        </Card.Body>
                      </Accordion.Collapse>
                    </Card>
                  ))}
                </Accordion> */}
              </Col>
            </Row>
          </Col>
        </Row>
        <Row className="mt-2">
          <Col className="mt-3">
            <Button className="login-btn mr-1" variant="primary-login" size="md" type="submit">
              {t('label:save')}
            </Button>
          </Col>
        </Row>
      </Form>
    </Card.Body>
  );
};

const mapStateToProps = (state) => ({});

const mapDispatchToProps = (dispatch) => ({
  createOrEditProfile: (payload, handleError) => {
    if (payload.id)
      dispatch({ type: ASYNC_EDIT_PROFILE, payload, handleError });
    else dispatch({ type: ASYNC_CREATE_PROFILE, payload, handleError });
  },
});

const reduxConnect = connect(mapStateToProps, mapDispatchToProps)(ProfilesForm);

export default MasterPage(reduxConnect);
